import { gql } from '@apollo/client'

import { FileFragment } from './FileFragment'
import { FileMetadataFragment } from './FileMetadataFragment'

export const SimpleOrderFragment = gql`
  ${FileMetadataFragment}
  fragment SimpleOrder on SimpleOrder {
    id
    createdAt
    updatedAt
    orderType
    orderCreatedOn
    storeId
    orderNumber
    kitchenRange
    processingPayment
    orderConfirmations {
      ...FileMetadata
    }
    signedOrder {
      ...FileMetadata
    }
    floorplan {
      ...FileMetadata
    }
    image {
      ...FileMetadata
    }
    receipts {
      ...FileMetadata
    }
    salesPerson
    orderStatus
    slottedDate
    paymentDueDate
    amountPaid
    grossValue
    vatAmount
    netValue
    includesInstallation
  }
`

export const MarbodalOrderFragment = gql`
  ${FileFragment}
  fragment MarbodalOrder on MarbodalOrder {
    id
    created
    updated
    errandId
    statusId
    lastChangeDate
    deliveryDate
    deliveryName
    deliveryAddress
    deliveryCity
    deliveryZipcode
    deliveryCountry
    fulfillmentId
    imageUrl
    assemblyInstructions {
      ...File
    }
    drawings {
      ...File
    }
    purchaseAgreement {
      ...File
    }
    deliveries {
      delivered
      trackingId
      items {
        articleNumber
        text
        delivered
      }
    }
    restItems {
      articleNumber
      text
      ordered
      delivered
      remaining
      preliminaryDeliveryDate
    }
  }
`

export const StormOrderFragment = gql`
  fragment StormOrder on StormOrder {
    id
    created
    updated
    total
    totalIncVat
    status
    deliveryMethod
    deliveryInformation
    items {
      name
      partNo
      image
      quantity
      price
      priceIncVat
      rowAmountIncVat
    }
    freight {
      name
      partNo
      image
      quantity
      price
      priceIncVat
      rowAmountIncVat
    }
    customer {
      email
      phoneNumber
      invoiceAddressAsDeliveryAddress
      allowDifferentDeliveryAddress
      invoiceAddress {
        firstName
        lastName
        careOf
        address
        address2
        postalCode
        city
      }
    }
  }
`
